import {IconSizeColorProps} from "./types";

export default function CheckboxCheckedIcon({
                                         size=16,
                                         color="#FC802D",
                                         ...props
                                     }:IconSizeColorProps) {
    return <svg width={size} height={size} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="1.33203" y="1.83325" width="13.3333" height="13.3333" rx="4" fill={color}/>
        <path
            d="M5.96094 7.63565L7.23226 8.90697L9.87499 6.26424C10.113 6.02621 10.4989 6.02621 10.737 6.26424C10.975 6.50227 10.975 6.8882 10.737 7.12623L7.80211 10.0611C7.48739 10.3758 6.97714 10.3758 6.66242 10.0611L5.09896 8.49764C4.86093 8.25961 4.86093 7.87368 5.09896 7.63565C5.33699 7.39762 5.72291 7.39762 5.96094 7.63565Z"
            fill="white"/>
    </svg>


}